<template>
 <div>
     <Timeline v-if="orderData">
         <TimelineItem class="green-line-pickup">
             <Icon type="md-flag" slot="dot"  color="green"></Icon>
              <span style="color: gray; font-size: 14px;">Dealer</span>
             <Card style="">
                 <Row :gutter="10">
                     <Col span="24">{{orderData.clientobject.name}}</Col>
                     <Col span="6">{{orderData.clientobject.mobile}} </Col>
                     <Col span="18">| &nbsp;&nbsp;{{orderData.clientobject.email}}</Col>
                 </Row>
             </Card>
         </TimelineItem>

   <!--  ------------------------ Pickup party of Original Order ------------------------------ -->
         <TimelineItem :class="orderData.orderDetails && orderData.orderDetails.pickupPoint.pickupPartyName?
             'green-line-pickup2':''" >
           <span style="color: gray; font-size: 14px;">{{orderData.orderDetails && orderData.orderDetails.pickupPoint.pickupPartyName?'Old pickup':'Pickup'}} point</span>
           <Icon type="md-car" :style="orderData.orderDetails && orderData.orderDetails.pickupPoint.pickupPartyName?
             'pointer-events:none;color: #cdcdcd;':''"  slot="dot"></Icon>
             <div>
             <Card :style="orderData.orderDetails && orderData.orderDetails.pickupPoint.pickupPartyName?
             'pointer-events:none;background: #f5f5f5;':''">
             <Row :gutter="10">
                 <Col span="24">{{orderData.pickuppartyobject.name}}
                   <i class="fas fa-edit" style="float: right; cursor: pointer;" @click="onEditPickupOfOrder"
                      v-if="orderData.orderDetails && !orderData.orderDetails.pickupPoint.pickupPartyName"></i>
                 </Col>
                 <Col span="6">{{orderData.pickuppartyobject.mobile}} </Col>
                 <Col span="18">| &nbsp;&nbsp;{{orderData.pickuppartyobject.email}}</Col>
                 <Col span="24" v-if="marketingContact">Marketing Contact: {{marketingContact.name}} ({{marketingContact.mobile}})</Col>
                 <Col span="24" v-if="dispatchContact">Dispatch Contact: {{dispatchContact.name}} ({{dispatchContact.mobile}})</Col>
             </Row>
             </Card>
             </div>
         </TimelineItem>
    <!-- -------------x-----------------x------------------x----------------x------------------- -->
    <!--  ------------------------ Pickup party of orderDetail ---------------------------------- -->
         <TimelineItem v-if="orderData.orderDetails && orderData.orderDetails.pickupPoint.pickupPartyName" class="grey-line">
             <Icon type="md-car"  slot="dot"></Icon>
           <span style="color: gray; font-size: 14px;">Pickup point</span>
             <Card>
                 <Row :gutter="10">
                     <Col span="24">{{orderData.orderDetails.pickupPoint.pickupPartyName}}
                       <i class="fas fa-edit" style="float: right; cursor: pointer;" @click="onEditPickupOfOrderDetail"></i>

                     </Col>
                     <Col span="6">{{orderData.orderDetails.pickupPoint.mobile?orderData.orderDetails.pickupPoint.mobile:''}} </Col>
                     <Col span="18">| &nbsp;&nbsp;{{orderData.orderDetails.pickupPoint.email?orderData.orderDetails.pickupPoint.email:''}}</Col>
                     <Col span="24" v-if="marketingContact">Marketing Contact: {{marketingContact.name}} ({{marketingContact.mobile}})</Col>
                     <Col span="24" v-if="dispatchContact">Dispatch Contact: {{dispatchContact.name}} ({{dispatchContact.mobile}})</Col>
                 </Row>
             </Card>
         </TimelineItem>
     <!-- -------------x-----------------x------------------x----------------x------------------- -->
         <TimelineItem :class="orderData.orderDetails && orderData.orderDetails.dropPoint &&
                       orderData.orderDetails.dropPoint.dropPartyName?'drop-point':''">
                <Icon type="md-flag" slot="dot" :style="orderData.orderDetails && orderData.orderDetails.dropPoint &&
                 orderData.orderDetails.dropPoint.dropPartyName?'pointer-events:none;color: #cdcdcd;':''" ></Icon>
                <span style="color: gray; font-size: 14px;">{{orderData.orderDetails && orderData.orderDetails.dropPoint &&
                 orderData.orderDetails.dropPoint.dropPartyName?'Old drop':'Drop'}} point</span>
                 <Card :style="orderData.orderDetails && orderData.orderDetails.dropPoint &&
                 orderData.orderDetails.dropPoint.dropPartyName?'pointer-events:none;background: #f5f5f5;':''">
                 <Row :gutter="10">
                     <Col span="24">{{orderData.droppingpartyobject.name}}
                       <i class="fas fa-edit" style="float: right; cursor: pointer;" @click="onEditDropOfOrder" v-if="orderData.orderDetails && orderData.orderDetails.dropPoint
                               && !orderData.orderDetails.dropPoint.dropPartyName"></i>
                     </Col>
                     <Col span="6">{{orderData.droppingpartyobject.mobile}} </Col>
                     <Col span="18">| &nbsp;&nbsp;{{orderData.droppingpartyobject.email}}</Col>
                 </Row>
                 </Card>
         </TimelineItem>
         <!--</TimelineItem class="drop-point2">-->

         <TimelineItem v-if="orderData.orderDetails && orderData.orderDetails.dropPoint &&
          orderData.orderDetails.dropPoint.dropPartyName">
             <Icon type="md-flag" slot="dot"></Icon>
             <Card>
                 <Row :gutter="10">
                     <Col span="24">{{orderData.orderDetails.dropPoint.dropPartyName}}
                         <i class="fas fa-edit" style="float: right; cursor: pointer;" @click="onEditDropOfOrderDetail"></i>
                     </Col>
                     <Col span="6">{{orderData.orderDetails.dropPoint.mobile?orderData.orderDetails.dropPoint.mobile:''}}</Col>
                     <Col span="18">| &nbsp;&nbsp;{{orderData.orderDetails.dropPoint.email?orderData.orderDetails.dropPoint.email:''}}</Col>
                 </Row>
             </Card>
         </TimelineItem>
     </Timeline>


     <Modal v-model="editPickupDialog" :mask-closable="false" width="550" draggable>
         <div slot="header"><strong>Edit Pickup party</strong></div>
         <div>
             <Form :model="pickupPartyForm" :rules="ruleValidatePickup" label-position="top" ref="pickupPartyForm">
                 <Row :gutter="10">
                     <Col span="24" style="margin: 0 0 -20px 0">
                         <FormItem prop="name">
                             <ApolloQuery :query="query_SEARCH_PICKUPPARTY" :debounce="500" :skip="skip.pickupPartySkip"
                                          :variables="{pickupPartyFilter:pickupPartyFilter, filterpickupPartyCity:[]}">
                                 <template slot-scope="{ result: { loading, error, data } }">
                                     <div v-if="loading"> Loading...</div>
                                     <div v-else-if="error"> Error Occured. {{error}}</div>
                                     <div v-else>
                                         <AutoComplete placeholder="Pickup Party" @on-search="onSearchPickupParty($event)"
                                                       v-model="pickupPartyForm.name">
                                             <Option :key="index" :value="companyObj.name" :label="companyObj.name"
                                                     v-for="(companyObj,index) in data?data.addressbookedcompany:[]">
                                                 <div class="ivu-select-item-div" @click="assignPickupParty(companyObj)">{{companyObj.name}}</div>
                                             </Option>
                                         </AutoComplete>
                                     </div>
                                 </template>
                             </ApolloQuery>
                         </FormItem>
                     </Col>
                     <Col span="24" style="margin: 0 0 -20px 0">
                         <FormItem  prop="add1">
                             <Input placeholder="Address 1" v-model="pickupPartyForm.add1"></Input>
                         </FormItem>
                     </Col>
                     <Col span="24" style="margin: 0 0 -20px 0">
                         <FormItem  prop="add2">
                             <Input placeholder="Address 2" v-model="pickupPartyForm.add2"></Input>
                         </FormItem>
                     </Col>
                     <Col span="12" style="margin: 0 0 -20px 0">
                         <FormItem prop="area">
                             <Input placeholder="Area" v-model="pickupPartyForm.area"></Input>
                         </FormItem>
                     </Col>
                     <Col span="12" style="margin: 0 0 -20px 0">
                         <FormItem  prop="pincode">
                             <Input number placeholder="PIN" v-model="pickupPartyForm.pincode"></Input>
                         </FormItem>
                     </Col>
                     <Col span="12" style="margin: 0 0 -20px 0">
                         <FormItem  prop="city" >
                             <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter}"
                                          :debounce="500" :skip="skip.citySkip">
                                 <template slot-scope="{ result: { loading, error, data } }">
                                     <div v-if="loading"> Loading...</div>
                                     <div v-else-if="error"> Error Occured. {{error}}</div>
                                     <div v-else>
                                         <AutoComplete placeholder="City" v-model="pickupPartyForm.city"
                                                       @on-search="onSearchCity">
                                             <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.territories:[]">
                                                 <div class="ivu-select-item-div">{{cityObj.city}}</div>
                                             </Option>
                                         </AutoComplete>
                                     </div>
                                 </template>
                             </ApolloQuery>
                         </FormItem>
                     </Col>
                     <Col span="12" style="margin: 0 0 -20px 0">
                         <FormItem prop="state" >
                             <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}"
                                          :debounce="500" :skip="skip.stateSkip">
                                 <template slot-scope="{ result: { loading, error, data } }">
                                     <div v-if="loading"> Loading...</div>
                                     <div v-else-if="error"> Error Occured. {{error}}</div>
                                     <div v-else>
                                         <AutoComplete placeholder="State" v-model="pickupPartyForm.state"
                                                       @on-search="onSearchState">
                                             <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data?data.territories:[]">
                                                 <div class="ivu-select-item-div">{{stateObj.state}}</div>
                                             </Option>
                                         </AutoComplete>
                                     </div>
                                 </template>
                             </ApolloQuery>
                         </FormItem>
                     </Col>
                 </Row>
             </Form>
         </div>
         <div slot="footer">
             <Button @click="checkPickupForm" class="btn-update" style="margin-right: 6px">Update</Button>
             <Button @click="editPickupDialog=false" class="btn-cancel">Cancel</Button>
         </div>
     </Modal>

     <Modal v-model="editDropPartyDialog" :mask-closable="false" width="550" draggable>
         <div slot="header"><strong>Edit Dropping party</strong></div>
         <div>
             <Form :model="dropPartyForm" :rules="ruleValidatedrop" label-position="top" ref="dropPartyForm">
                 <Row :gutter="10">
                     <Col span="24" style="margin: 0 0 -20px 0">
                         <FormItem prop="name">
                             <ApolloQuery :query="query_SEARCH_DROPPINGPARTY" :debounce="500" :skip="skip.dropPartySkip"
                                          :variables="{droppingPartyFilter:dropPartyFilter, filterDroppingCity:[]}">
                                 <template slot-scope="{ result: { loading, error, data } }">
                                     <div v-if="loading"> Loading...</div>
                                     <div v-else-if="error"> Error Occured. {{error}}</div>
                                     <div v-else>
                                         <AutoComplete placeholder="Drop Party" @on-search="onSearchDropParty($event)"
                                                       v-model="dropPartyForm.name">
                                             <Option :key="index" :value="companyObj.name" :label="companyObj.name"
                                                     v-for="(companyObj,index) in data?data.addressbookedcompany:[]">
                                                 <div class="ivu-select-item-div" @click="assignDropParty(companyObj)">{{companyObj.name}}</div>
                                             </Option>
                                         </AutoComplete>
                                     </div>
                                 </template>
                             </ApolloQuery>
                         </FormItem>
                     </Col>
                     <Col span="24" style="margin: 0 0 -20px 0">
                         <FormItem  prop="add1">
                             <Input placeholder="Address 1" v-model="dropPartyForm.add1"></Input>
                         </FormItem>
                     </Col>
                     <Col span="24" style="margin: 0 0 -20px 0">
                         <FormItem  prop="add2">
                             <Input placeholder="Address 2" v-model="dropPartyForm.add2"></Input>
                         </FormItem>
                     </Col>
                     <Col span="12" style="margin: 0 0 -20px 0">
                         <FormItem prop="area">
                             <Input placeholder="Area" v-model="dropPartyForm.area"></Input>
                         </FormItem>
                     </Col>
                     <Col span="12" style="margin: 0 0 -20px 0">
                         <FormItem  prop="pincode">
                             <Input number placeholder="PIN" v-model="dropPartyForm.pincode"></Input>
                         </FormItem>
                     </Col>
                     <Col span="12" style="margin: 0 0 -20px 0">
                         <FormItem  prop="city" >
                             <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter}"
                                          :debounce="500" :skip="skip.citySkip">
                                 <template slot-scope="{ result: { loading, error, data } }">
                                     <div v-if="loading"> Loading...</div>
                                     <div v-else-if="error"> Error Occured. {{error}}</div>
                                     <div v-else>
                                         <AutoComplete placeholder="City" v-model="dropPartyForm.city"
                                                       @on-search="onSearchCity">
                                             <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.territories:[]">
                                                 <div class="ivu-select-item-div">{{cityObj.city}}</div>
                                             </Option>
                                         </AutoComplete>
                                     </div>
                                 </template>
                             </ApolloQuery>
                         </FormItem>
                     </Col>
                     <Col span="12" style="margin: 0 0 -20px 0">
                         <FormItem prop="state" >
                             <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}"
                                          :debounce="500" :skip="skip.stateSkip">
                                 <template slot-scope="{ result: { loading, error, data } }">
                                     <div v-if="loading"> Loading...</div>
                                     <div v-else-if="error"> Error Occured. {{error}}</div>
                                     <div v-else>
                                         <AutoComplete placeholder="State" v-model="dropPartyForm.state"
                                                       @on-search="onSearchState">
                                             <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data?data.territories:[]">
                                                 <div class="ivu-select-item-div">{{stateObj.state}}</div>
                                             </Option>
                                         </AutoComplete>
                                     </div>
                                 </template>
                             </ApolloQuery>
                         </FormItem>
                     </Col>
                 </Row>
             </Form>
         </div>
         <div slot="footer">
             <Button @click="checkDropForm" class="btn-update">Update</Button>
             <Button @click="editDropPartyDialog=false" class="btn-cancel">Cancel</Button>
         </div>
     </Modal>
   <template v-if="orderData.note">
   <h3>Notes</h3>
     <Card>{{orderData.note}}</Card>
<!--   <div class="notes">
     <div class="lines"></div>
     <div class="list"></div>
   </div>         -->
   </template>

 </div>
</template>

<script>
    import {SEARCH_PICKUPPARTY, SEARCH_DROPPINGPARTY} from '../../graphql/queries/companies'
    import {GET_CONTACT_BY_ID} from '../../graphql/queries/contacts'
    import { SEARCH_CITY, SEARCH_STATE } from '../../graphql/queries/territories'
    import ValidationRules from '../../Constants/ValidationRules'
    import {CREATE_UPDATE_ORDER_COMPANY} from "../../graphql/mutations/companies";
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";
    export default {
        name: "TimeHistory",
        props:['orderId'],
        data: function(){
            return{
                query_SEARCH_PICKUPPARTY: SEARCH_PICKUPPARTY,
                query_SEARCH_DROPPINGPARTY: SEARCH_DROPPINGPARTY,
                query_SEARCH_CITY: SEARCH_CITY,
                query_SEARCH_STATE: SEARCH_STATE,
                query_GET_CONTACT_BY_ID: GET_CONTACT_BY_ID,
                orderData: '',
             /* ------------------------ */
                editPickupDialog:false,
                pickupPartyForm:{
                    name: '',
                    pickupId: '',
                    mobile: '',
                    email: '',
                    add1: '',
                    add2: '',
                    area: '',
                    pincode: '',
                    state: '',
                    city: ''
                },
                ruleValidatePickup: {name: ValidationRules.textField('Name')},
                pickupPartyFilter: '%%',
             /* -------------------------- */
                editDropPartyDialog:false,
                dropPartyForm:{
                    name: '',
                    dropPartyId: '',
                    mobile: '',
                    email: '',
                    add1: '',
                    add2: '',
                    area: '',
                    pincode: '',
                    state: '',
                    city: ''
                },
                ruleValidatedrop: {name: ValidationRules.textField('Name')},
                dropPartyFilter: '%%',
             /* ------------------------ */
                cityFilter: '%%',
                stateFilter: '%%',
                skip: {pickupPartySkip: true, dropPartySkip: true, citySkip: true, stateSkip: true},
                marketingContact: null,
                dispatchContact: null,
            }
        },
        methods:{
            onSearchPickupParty: function(val){
                this.pickupPartyFilter = '%' + val + '%';
                this.skip.pickupPartySkip = false;
            },
            assignPickupParty(companyObj){
                this.pickupPartyForm.pickupId = companyObj.id;
                this.pickupPartyForm.mobile = companyObj.mobile;
                this.pickupPartyForm.email = companyObj.email;
            },
            onSearchDropParty: function(val){
                this.dropPartyFilter = '%' + val + '%';
                this.skip.dropPartySkip = false;
            },
            assignDropParty(companyObj){
                this.dropPartyForm.dropPartyId = companyObj.id;
                this.dropPartyForm.mobile = companyObj.mobile;
                this.dropPartyForm.email = companyObj.email;
            },
            onSearchCity: function(val){
                this.cityFilter = '%' + val + '%';
                this.skip.citySkip = false;
            },
            onSearchState: function(val){
                this.stateFilter = '%' + val + '%';
                this.skip.stateSkip = false;
            },
            reset: function(){
                this.$refs['pickupPartyForm'].resetFields();

            },
            onEditPickupOfOrder(){
                this.pickupPartyForm.name = this.orderData.pickuppartyobject.name;
                this.pickupPartyForm.pickupId = this.orderData.pickuppartyobject.id;
                this.pickupPartyForm.mobile = this.orderData.pickuppartyobject.mobile;
                this.pickupPartyForm.email = this.orderData.pickuppartyobject.email;
                this.pickupPartyForm.add1 = this.orderData.pickuppartyobject.address[0].add1;
                this.pickupPartyForm.add2 = this.orderData.pickuppartyobject.address[0].add2;
                this.pickupPartyForm.area = this.orderData.pickuppartyobject.address[0].area;
                this.pickupPartyForm.pincode = this.orderData.pickuppartyobject.address[0].pincode;
                this.pickupPartyForm.state = this.orderData.pickuppartyobject.address[0].state;
                this.pickupPartyForm.city = this.orderData.pickuppartyobject.address[0].city;
              this.editPickupDialog = true
            },
            onEditPickupOfOrderDetail(){
                this.pickupPartyForm.name = this.orderData.orderDetails.pickupPoint.pickupPartyName;
                this.pickupPartyForm.pickupId = this.orderData.orderDetails.pickupPoint.pickupPartyId;
                this.pickupPartyForm.mobile = this.orderData.orderDetails.pickupPoint.mobile?
                    this.orderData.orderDetails.pickupPoint.mobile:'';
                this.pickupPartyForm.email = this.orderData.orderDetails.pickupPoint.email?
                    this.orderData.orderDetails.pickupPoint.email:'';
                this.pickupPartyForm.pickupId = this.orderData.orderDetails.pickupPoint.pickupPartyId;
                this.pickupPartyForm.add1 = this.orderData.orderDetails.pickupPoint.add1;
                this.pickupPartyForm.add2 = this.orderData.orderDetails.pickupPoint.add2;
                this.pickupPartyForm.area = this.orderData.orderDetails.pickupPoint.area;
                this.pickupPartyForm.pincode = this.orderData.orderDetails.pickupPoint.pincode;
                this.pickupPartyForm.state = this.orderData.orderDetails.pickupPoint.state;
                this.pickupPartyForm.city = this.orderData.orderDetails.pickupPoint.city;
                this.editPickupDialog = true
            },
            onEditDropOfOrder(){
                this.dropPartyForm.name = this.orderData.droppingpartyobject.name;
                this.dropPartyForm.dropPartyId = this.orderData.droppingpartyobject.id;
                this.dropPartyForm.mobile = this.orderData.droppingpartyobject.mobile;
                this.dropPartyForm.email = this.orderData.droppingpartyobject.email;
                this.dropPartyForm.add1 = this.orderData.droppingpartyobject.address[0].add1;
                this.dropPartyForm.add2 = this.orderData.droppingpartyobject.address[0].add2;
                this.dropPartyForm.area = this.orderData.droppingpartyobject.address[0].area;
                this.dropPartyForm.pincode = this.orderData.droppingpartyobject.address[0].pincode;
                this.dropPartyForm.state = this.orderData.droppingpartyobject.address[0].state;
                this.dropPartyForm.city = this.orderData.droppingpartyobject.address[0].city;
                this.editDropPartyDialog = true
            },
            onEditDropOfOrderDetail(){
                this.dropPartyForm.name = this.orderData.orderDetails.dropPoint.dropPartyName;
                this.dropPartyForm.dropPartyId = this.orderData.orderDetails.dropPoint.dropPartyId;
                this.dropPartyForm.mobile = this.orderData.orderDetails.dropPoint.mobile?
                    this.orderData.orderDetails.dropPoint.mobile:'';
                this.dropPartyForm.email = this.orderData.orderDetails.dropPoint.email?
                    this.orderData.orderDetails.dropPoint.email:'';
                this.dropPartyForm.add1 = this.orderData.orderDetails.dropPoint.add1;
                this.dropPartyForm.add2 = this.orderData.orderDetails.dropPoint.add2;
                this.dropPartyForm.area = this.orderData.orderDetails.dropPoint.area;
                this.dropPartyForm.pincode = this.orderData.orderDetails.dropPoint.pincode;
                this.dropPartyForm.state = this.orderData.orderDetails.dropPoint.state;
                this.dropPartyForm.city = this.orderData.orderDetails.dropPoint.city;
                this.editDropPartyDialog = true
            },
            async checkPickupForm(){
                this.$refs['pickupPartyForm'].validate(async (valid) => {
                    if(valid) {
                      let {pickupId:pickupPartyId, name:pickupPartyName, ...rest} = this.pickupPartyForm
                      let mappedAreas = this.$store.state.mappedAreas
                      let obj = { pickupPoint: {pickupPartyId, pickupPartyName, ...rest},
                                  pickupAreaGroup: mappedAreas[this.pickupPartyForm.area.toLowerCase()] || null}
                      await this.updateRecord(this.orderData.orderDetails.id, obj, 'orderDetails')
                      this.editPickupDialog = false
                      this.saveOrderPickupCompany()                                  //Saved in separate table
                    }
                })
            },
            async saveOrderPickupCompany(){
                let response = await this.$apollo.mutate({
                  mutation: CREATE_UPDATE_ORDER_COMPANY,
                  variables: {
                    orderCompany: {
                      name: this.pickupPartyForm.name,
                      mobile: this.pickupPartyForm.mobile,
                      email: this.pickupPartyForm.email,
                      addressLine1: this.pickupPartyForm.add1,
                      addressLine2: this.pickupPartyForm.add2,
                      area: this.pickupPartyForm.area,
                      city: this.pickupPartyForm.city,
                      state: this.pickupPartyForm.state,
                      pincode: this.pickupPartyForm.pincode,
                      originalCompanyId: this.pickupPartyForm.pickupId,
                      type: 'PICKUP',
                      orderId: this.orderData.id
                    },
                    updateColumns: ['name', 'mobile', 'email', 'addressLine1', 'addressLine2', 'area', 'city', 'state', 'pincode', 'originalCompanyId']
                  }
                })
                // if(response.data) this.$Message.success('Order Company saved successfully!')
            },
            async checkDropForm(){
                this.$refs['dropPartyForm'].validate(async (valid) => {
                    if (valid) {
                      let {name:dropPartyName, ...rest} = this.dropPartyForm
                      let mappedAreas = this.$store.state.mappedAreas
                      let obj = { dropPoint: {dropPartyName, ...rest},
                                  dropAreaGroup: mappedAreas[this.dropPartyForm.area.toLowerCase()] || null}
                      await this.updateRecord(this.orderData.orderDetails.id, obj, 'orderDetails')
                      this.editDropPartyDialog = false
                      this.saveOrderDropCompany();
                    }
                })
            },
            async saveOrderDropCompany(){
                let response = await this.$apollo.mutate({
                  mutation: CREATE_UPDATE_ORDER_COMPANY,
                  variables: {
                    orderCompany: {
                      name: this.dropPartyForm.name,
                      mobile: this.dropPartyForm.mobile,
                      email: this.dropPartyForm.email,
                      addressLine1: this.dropPartyForm.add1,
                      addressLine2: this.dropPartyForm.add2,
                      area: this.dropPartyForm.area,
                      city: this.dropPartyForm.city,
                      state: this.dropPartyForm.state,
                      pincode: this.dropPartyForm.pincode,
                      originalCompanyId: this.dropPartyForm.dropPartyId,
                      type: 'DROP',
                      orderId: this.orderData.id
                    },
                    updateColumns: ['name', 'mobile', 'email', 'addressLine1', 'addressLine2', 'area', 'city', 'state', 'pincode', 'originalCompanyId']
                  }
                })
                // if(response.data) this.$Message.success('Order Company saved successfully!')
            },
            async updateRecord(id, obj, table){
              // this[loaderStr] = true
              let response = await this.$apollo.mutate({
                mutation: generate_UPDATE_ORDER_DATA(table),
                variables: { id: id, obj: obj}
              })
              if(response.data){
                this.$Message.success('Order updated successfully!')
                // this[loaderStr] = false
              }
            },
            async getContacts(orderData){
                if(orderData.pickuppartyobject.mktgContactId){
                    let queryMktgResponse = await this.$apollo.query({
                        query: this.query_GET_CONTACT_BY_ID,
                        variables: {id: orderData.pickuppartyobject.mktgContactId},
                        fetchPolicy: "network-only"
                    })
                    if(queryMktgResponse.data){
                        this.marketingContact = queryMktgResponse.data.contacts[0]
                    }
                }else{
                    this.marketingContact = null
                }
                if(orderData.pickuppartyobject.dispatchContactId){
                    let querydispatchResponse = await this.$apollo.query({
                        query: this.query_GET_CONTACT_BY_ID,
                        variables: {id: orderData.pickuppartyobject.dispatchContactId},
                        fetchPolicy: "network-only"
                    })
                    if(querydispatchResponse.data){
                        this.dispatchContact = querydispatchResponse.data.contacts[0]
                    }
                }else{
                    this.dispatchContact = null
                }

            }
        },
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-date-picker-cells{
        width: 259px !important;
    }
    /deep/ .ivu-date-picker-cells span{
        width: 37px !important;
        margin: 0;
        font-size: 15px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
    .btn-cancel{
        float: right;
    }
    .btn-update{
        float: right;
        margin-bottom: 8px;
        margin-left: 10px;
    }
  /deep/ .grey-line > div.ivu-timeline-item-tail{
    border-left: 1px solid #cdcdcd !important;
  }
    /deep/ .grey-line > div.ivu-timeline-item-head{
      color: #00af00;
    }
  /deep/ .green-line-pickup > div.ivu-timeline-item-tail{
    border-left: 1px solid #00af00 !important;
  }
  /deep/ .green-line-pickup2 > div.ivu-timeline-item-head{
    display: none;
  }
    /deep/ .green-line-pickup2 > div.ivu-timeline-item-tail{
      border-left: 1px solid #00af00 !important;
    }
    /deep/ .drop-point > div.ivu-timeline-item-head{
      display: none;
      border-left: 1px solid #cdcdcd !important;
    }
    /deep/ .drop-point > div.ivu-timeline-item-tail{
      border-left: 1px solid #cdcdcd !important;
    }
    .notes {
      background-color :#f5f5f5;
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding: 0;
      overflow: hidden;
      position: relative;
    }

    .list {
      color: #555;
      font-size: 22px;
      padding: 0 !important;
      font-family: courier, monospace;
      border: 1px solid #dedede;
      margin-left: 40px;

    }
    .list li {
      list-style: none;
      border-bottom: 1px dotted #ccc;
      text-indent: 25px;
      height: auto;
      padding: 10px;
      text-transform: capitalize;

    }
    .list li:hover {
      background-color: #f0f0f0;
      -webkit-transition: all 0.2s;
      -moz-transition:    all 0.2s;
      -ms-transition:     all 0.2s;
      -o-transition:      all 0.2s;
    }
    .lines {
      border-left: 1px solid #ffaa9f;
      border-right: 1px solid #ffaa9f;
      width: 3px;
      float: left;
      height: 100%;
      margin-left: 30px;
      position: absolute;

    }


</style>

